import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import RadioBullet from '@bubble-ui/atom-radio-bullet';
import View from '@bubble-ui/primitive-view';
import Text from '@bubble-ui/primitive-text';
import { getDefaultOptionStyleSheet } from './getDefaultOptionStyleSheet';
import { defaultDesignTokens } from './defaultDesignTokens';
var getIds = id => id ? {
  input: "".concat(id, "__input"),
  label: "".concat(id, "__label"),
  radioMark: "".concat(id, "__radio-mark")
} : {};
var RadioGroupOptionComponent = _ref => {
  var {
    hovered,
    id,
    isChecked,
    isDisabled,
    keyboardFocused,
    label,
    name,
    onChange,
    pressed,
    value
  } = _ref;
  var ids = getIds(id);
  var designContext = useDesignContext(defaultDesignTokens);
  var [interactiveState, eventHandlers] = useInteractiveStateCombined({
    disabled: isDisabled,
    hovered,
    pressed,
    keyboardFocused
  });
  var {
    inputStyle,
    optionWrapperStyle,
    labelWrapperStyle,
    paragraphSecondaryCorrectFootprintStyle
  } = getDefaultOptionStyleSheet({
    designContext,
    isDisabled
  });
  var handleOnChange = useCallback(e => {
    if (onChange) {
      onChange(value, e);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);
  return /*#__PURE__*/React.createElement(View, eventHandlers, /*#__PURE__*/React.createElement("label", {
    id: ids.label,
    htmlFor: ids.input
  }, /*#__PURE__*/React.createElement("input", {
    style: inputStyle,
    name: name,
    id: ids.input,
    type: "radio",
    checked: isChecked,
    disabled: isDisabled,
    onChange: handleOnChange
  }), /*#__PURE__*/React.createElement(View, {
    style: optionWrapperStyle
  }, /*#__PURE__*/React.createElement(RadioBullet, _extends({
    excludeInput: true,
    id: ids.radioMark,
    name: "".concat(name, "__options"),
    checked: isChecked,
    disabled: isDisabled
  }, interactiveState)), /*#__PURE__*/React.createElement(View, {
    id: ids.label,
    style: labelWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "paragraph",
    style: paragraphSecondaryCorrectFootprintStyle
  }, label)))));
};
export var RadioGroupOption = withProvisionalOverrideFromContext(RadioGroupOptionComponent);
//# sourceMappingURL=RadioGroupOption.js.map